var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("main", {
    staticClass: "file-upload"
  }, [_c("a-upload", {
    staticClass: "upload-list-inline",
    attrs: {
      accept: _vm.accept,
      "before-upload": _vm.beforeUpload,
      "file-list": _vm.fileList,
      showUploadList: false,
      multiple: false,
      remove: _vm.handleFileRemove,
      customRequest: function customRequest(_ref) {
        var action = _ref.action,
          file = _ref.file,
          onSuccess = _ref.onSuccess,
          onError = _ref.onError,
          onProgress = _ref.onProgress;
        return _vm.handleUploadChange({
          action: action,
          file: file,
          onSuccess: onSuccess,
          onError: onError,
          onProgress: onProgress
        });
      }
    },
    on: {
      change: _vm.handleChange
    }
  }, [_c("div", [_c("a-button", [_c("a-icon", {
    attrs: {
      type: "upload"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("form.pdfUpload")))], 1)], 1)])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };